import styles from "./styles"

function useStyles(theme, styles) {
  return styles;
}

export default (theme) => styles;
export { styles as systemStyles }
export { useStyles }
